// extracted by mini-css-extract-plugin
export default {"body":"DashboardHeroCard_body__PM1iR","text":"DashboardHeroCard_text__E+LPq"};